'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserPlanBadge = require('../../../../../components/userAvatar/UserPlanBadge');

var _UserPlanBadge2 = _interopRequireDefault(_UserPlanBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanTypeDetailSection = function PlanTypeDetailSection(_ref) {
    var subscriptionDetail = _ref.subscriptionDetail,
        currentUser = _ref.currentUser;

    if (!subscriptionDetail) return null;

    return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement(
            'div',
            { className: 'plan' },
            _react2.default.createElement(
                'div',
                { className: 'status' },
                _react2.default.createElement(
                    'h1',
                    null,
                    'You\u2019re on the Professional plan'
                )
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_UserPlanBadge2.default, { user: currentUser })
            )
        )
    );
};

PlanTypeDetailSection.propTypes = {
    currentUser: _propTypes2.default.object,
    subscriptionDetail: _propTypes2.default.object
};

exports.default = PlanTypeDetailSection;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/plan/pro/planSections/PlanTypeDetailSection.js
// module id = 2074
// module chunks = 0